import { Col, Row } from "antd";
import { labelStyle } from "../constants";
import { SwitchContainer } from "./styles";
import { useMobileAppVersionContext } from "../../../context/MobileAppVersionContext/MobileAppVersionContext";
import SwitchOptionComponent from "../../../components/SwitchComponent";

const ForceUpdateSettings = () => {
	const { mobileAppVersionData, setMobileAppVersionData } = useMobileAppVersionContext();

	const handleForceUpdateChange = (checked: boolean) => {
		setMobileAppVersionData({ ...mobileAppVersionData, forceUpdate: checked });
	};

	const handleHasWarningChange = (checked: boolean) => {
		setMobileAppVersionData({ ...mobileAppVersionData, hasWarning: checked });
	};

	return (
		<>
			<Row gutter={20}>
				<Col span={10}>
					<SwitchContainer>
						<SwitchOptionComponent
							title="Force Update"
							labelStyle={labelStyle}
							value={mobileAppVersionData?.forceUpdate}
							onChange={handleForceUpdateChange}
						/>
					</SwitchContainer>
				</Col>
				<Col span={10}>
					<SwitchContainer>
						<SwitchOptionComponent
							title="Uyarı Göster"
							labelStyle={labelStyle}
							value={mobileAppVersionData?.hasWarning}
							onChange={handleHasWarningChange}
						/>
					</SwitchContainer>
				</Col>
			</Row>
		</>
	);
};

export default ForceUpdateSettings;
